import { isDefined } from 'common';

import { useReactFlowViewContext } from '../../../context/context';
import { BlockInnerSelectField } from '../SelectField';
import { type ConfigFieldProps } from '../types';

interface DynamicFieldBlockValueProps extends ConfigFieldProps {
  fieldId: string;
}

export function DynamicFieldBlockValue(props: DynamicFieldBlockValueProps) {
  const { fieldId, fieldName } = props;
  const { getAllParentNodeNames, selectedNodeId } = useReactFlowViewContext();
  if (!isDefined(selectedNodeId)) {
    return null;
  }
  const blockNames = getAllParentNodeNames(selectedNodeId).sort((nameA, nameB) =>
    nameA.localeCompare(nameB, undefined, { sensitivity: 'base' })
  );
  return (
    <BlockInnerSelectField
      id={fieldId}
      fieldName={`${fieldName}.blockName`}
      options={blockNames.map((name) => ({ label: name, value: name }))}
      aria-label="Block"
      clearable={false}
    />
  );
}
